export const toUppercase = (value) => {
    return value.toLocaleUpperCase('el').replace(/([ΆΈΉΊΪΌΎΫΏ])/g, (match) => match.toLocaleLowerCase());
};
